export enum VideoSubEvent {
    SUCCESS = 'success',
    ERROR = 'error',

    ATTACHED = 'attached',
    EVENT = 'event',

    ICE_STATE = 'iceState',
    WEBRTC_STATE = 'webrtcState',
    ON_REMOTE_STREAM = 'onremotestream',
    ON_CLEAN_UP = 'oncleanup',

    SET = 'set',
}

export const maxFeed: number = 6;